import { useEffect, useState } from "react"
import styles from 'styles/News.module.css';
import DefaultThumbnail from 'assets/images/news/AREA_CUP_logo_original.png';
import TopNewsLogo from 'assets/images/news/top_news.png';
import TopNewsLogoHorizontal from 'assets/images/news/top_news_horizontal.png';
import { NewsData } from 'interfaces/news';
import { getNews } from 'lib/api/news';
import { useNavigate } from 'react-router-dom';

const News = () => {
  const [newsData, setNewsData] = useState<NewsData[]>([]);
  const handleGetNews = async () => {
    const res = await getNews(3)

    if (res.status == 200) {
      setNewsData(res.data)
    }
  }

  useEffect(() => {
    handleGetNews()
  }, [])

  const formatDate = (dateInput: Date): string => {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}.${month}.${day}`;
  }

  const navigate = useNavigate();

  const handleButtonClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className={styles["news-background"]} id="news">
      <div className={styles["card-container"]}>
        <img src={TopNewsLogoHorizontal} className={styles["logo-horizontal"]} alt="最新情報"/>
        <img src={TopNewsLogo} className={styles["logo"]} alt="最新情報"/>
        <div className={styles["card-container-main"]}>
          {newsData.map((item) => (
            <div className={styles["card"]} onClick={() => handleButtonClick(`/news/${item.urlHash}`)}>
              <img src={item.thumbnail || DefaultThumbnail} alt={item.title} />
              <div className={styles["card-content"]}>
                <div className={styles["card-content-info"]}>
                  <span className={styles["label"]} style={{ backgroundColor: item.newsLabelColorCode }}>{item.newsLabel}</span>
                  <span className={styles["date"]}>{formatDate(item.releasedAt)}</span>
                </div>
                <h3>{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
        <div className={styles["button-container"]}>
          <button className={styles["view-all-button"]} onClick={() => handleButtonClick('/news')}>VIEW ALL →</button>
        </div>
      </div>
    </div>
  );
};

export default News;
